import { putUbo, postUbo } from "../../../services/httpCalls";
import { cleanObject } from "../clean-object";

export const handleSubmit = async ({
  values,
  setShowLoader,
  filesAdded,
  editFlag,
  editData,
  notify,
  form,
  handleClose,
  setRefresh,
  setFilesAdded,
  setUboValidated,
  partnerState,
}) => {
  if (partnerState.includes("payglocal")) {
    if (!form.getFieldValue("phoneNumber")) {
      form.setFields([
        {
          name: "phoneNumber",
          errors: ["Required!"],
        },
      ]);
      return;
    }
  }

  setShowLoader(true);
  let orgId = localStorage.getItem("orgId");
  let data = {};
  if (partnerState?.includes("payglocal")) {
    data = {
      name: values?.lastName
        ? values.firstName + " " + values.lastName
        : values.firstName,
      firstName: values.firstName,
      lastName: values.lastName,
      dob: values?.dob?.format("DD/MM/YYYY"),
      phoneNumber: values.phoneNumber,
      designation: values.designation,
      status: "ACTIVE",
      idNumber: values.pan,
      emailId: values.emailId,
      docs: filesAdded,
      nationality: values.nationality,
    };
  } else {
    data = {
      name: values?.lastName
        ? values.firstName + " " + values.lastName
        : values.firstName,
      firstName: values.firstName,
      lastName: values.lastName,
      dob: values?.dob?.format("DD/MM/YYYY"),
      shareholdingPercentage: values.percentage,
      phoneNumber: values.phoneNumber,
      gender: values.gender,
      nationality: values.nationality,
      designation: values.designation,
      status: "ACTIVE",
      idNumber: values.idNumber,
      address:
        values.addressLineOne &&
        values.addressLineTwo &&
        values.city &&
        values.country &&
        values.pincode
          ? {
              addressLineOne: values.addressLineOne,
              addressLineTwo: values.addressLineTwo,
              city: values.city,
              state: values.state,
              country: values.country,
              pinCode: values.pincode,
            }
          : null,
      docs: filesAdded,
    };
  }
  if (editFlag) {
    let cleanData = cleanObject(data);
    await putUbo(cleanData, orgId, editData.id)
      .then((res) => {
        if (res) {
          notify.success("Updated UBO!");
          form.resetFields();
          handleClose();
          setRefresh(true);
          setFilesAdded([]);
          setUboValidated(true);
        }
      })
      .catch(() => {
        notify.error("UBO not updated found error!");
      })
      .finally(() => {
        setShowLoader(false);
      });
  } else {
    let cleanData = cleanObject(data);
    await postUbo(cleanData, orgId)
      .then((res) => {
        if (res) {
          setUboValidated(true);
          notify.success("Added UBO!");
          form.resetFields();
          handleClose();
          setRefresh(true);
        }
      })
      .catch(() => {
        notify.error("Not able to add UBO!");
      })
      .finally(() => {
        setShowLoader(false);
      });
  }
};
